import { Component } from "@angular/core";
import { UserService } from "src/app/core/auth";
import { NoticePageComponent } from "src/app/core/layout/notice-page.component";

@Component({
  selector: "mr-invalid-carrier",
  template: `
    <mr-notice-page
      message="Carrier association invalid. Contact your administrator."
    ></mr-notice-page>
  `,
  imports: [NoticePageComponent],
})
export class InvalidCarrierComponent {
  public constructor(private readonly user: UserService) {}

  public logout(): void {
    this.user.logout();
  }
}
